import { env } from './env';
import type { SubscriptionProvider } from './subscriptionProviders';
import { SUBSCRIPTION_PROVIDERS } from './subscriptionProviders';

const SUBSCRIPTION_APP_NAME = env.NEXT_PUBLIC_SHOPIFY_SUBSCRIPTION_APPNAME;

export const SUBSCRIPTION_PROVIDER: SubscriptionProvider =
  SUBSCRIPTION_PROVIDERS[SUBSCRIPTION_APP_NAME];
